import { render, staticRenderFns } from "./table-4.vue?vue&type=template&id=5081d1f0&scoped=true"
import script from "./table-4.vue?vue&type=script&lang=js"
export * from "./table-4.vue?vue&type=script&lang=js"
import style0 from "./table-4.vue?vue&type=style&index=0&id=5081d1f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5081d1f0",
  null
  
)

export default component.exports